import React, { useEffect, useState } from "react";
import { Box, Input, Textarea, Button, Flex, useToast, SimpleGrid, Heading } from "@chakra-ui/react";
import { getRecommendations } from "../../../../../services/webService";
import { saveVideoRecommendations } from "../../../../../services/adminService";

const EditVideoRecommendations = ({ clerkId }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [videos, setVideos] = useState({});
  const [title, setTitle] = useState("");
  const [url, setUrl] = useState("");
  const toast = useToast();

  useEffect(() =>{
    const fetchRecommendations = async() =>{
      try{
        const recommendationsVideos = await getRecommendations();
        setVideos(recommendationsVideos);
      } catch(error){
        console.error('Error fetching recommendations videos');
      }
    }
    fetchRecommendations();
  }, [])

  const handleSave = async (videoId) => {
    const updatedRecommendations = {
      id: videoId,
      title,  
      url,  
    };    

    try {
      const response = await saveVideoRecommendations(updatedRecommendations, clerkId);
      if (response.status === 200) {
        toast({
          title: 'Video recommendation updated.',
          description: 'Video information has been updated successfully.',
          status: 'success',
          duration: 3000,
          isClosable: true,
        }); 
        setVideos((prevVideos) =>
            prevVideos.map((video) =>
              video.id === videoId ? { ...video, url, title } : video
            )
          );
      } else{
        toast({
          title: 'Error',
          description: 'Error while trying to update video info.',
          status: 'error',
          duration: 3000,
          isClosable: true,
        })
      }
      setIsEditing(false);
      console.log("Video updated successfully!");
    } catch (error) {
      console.error("Error saving teacher:", error);
    }
  };


  const handleCancel = () => {
    setTitle("");
    setUrl(""); 
    setIsEditing(null); 
  };

  return (
  <Flex flexDirection="column" p={4} alignItems="center"  mb={4}>
    <Heading mb={4}>Edit video recommendations</Heading>
      {videos.length > 0 ? (
        <SimpleGrid columns={[1, 3]} spacing={10}> 
          {videos.map((video) => (
            <Flex key={video.id} flexDirection="column" p={4} border="1px solid #ccc">
              {isEditing === video.id ? (
                <>
                  <Input
                    placeholder="Title"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    mb={4}
                    dir="rtl"
                  />
                  <Textarea
                    placeholder="URL"
                    value={url}
                    onChange={(e) => setUrl(e.target.value)}
                    mb={4}
                    dir="rtl"
                  />
                  <Flex mt={4}>
                    <Button
                      colorScheme="green"
                      onClick={() => handleSave(video.id)} // Save the specific video
                      mr={2}
                    >
                      Save
                    </Button>
                    <Button colorScheme="gray" onClick={handleCancel}>
                      Cancel
                    </Button>
                  </Flex>
                </>
              ) : (
                <>
                  <Box textAlign="center">
                    <Box fontSize="xl" fontWeight="bold" dir="rtl" mb={2}>
                      {video.title}
                    </Box>
                    <Box>              
                      <iframe
                        width="100%"
                        height="100%"
                        src={video.url}
                        title={`Video player: ${video.title}`}                
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerPolicy="strict-origin-when-cross-origin"
                        allowFullScreen
                      ></iframe>
                    </Box>
                  </Box>
                  <Button colorScheme="blue" onClick={() => {
                    setIsEditing(video.id); 
                    setTitle(video.title); 
                    setUrl(video.url);
                  }}
                  mt={2}>
                    Edit
                  </Button>
                </>
              )}
            </Flex>
          ))}
        </SimpleGrid>
      ) : (
        <Box>No videos found</Box>
      )}
    </Flex>
  );
};


export default EditVideoRecommendations;
